/* src/app/details/details.component.scss */
.wrapper {
  margin-top: 20px;
  padding: 20px;
  color: #fff;
}
/*# sourceMappingURL=details.component.css.map */
